export default __webpack_public_path__ + "static/media/colissimo-logo.4817f99f.png";